"use client";

import { Card, CardHeader, CardContent } from "@heroui/react";
import { motion } from "motion/react";

import { Description, Title } from "./section-heading";

interface InfoCardProps {
  title: string;
  description: string;
  number: number;
  className?: string;
}

const cardMotionVariants = {
  hidden: { opacity: 0, scale: 0.8, filter: "blur(10px)" },
  visible: {
    opacity: 1,
    scale: 1,
    filter: "blur(0px)",
  },
};

export default function InfoCard({
  title,
  description,
  number,
  className,
}: InfoCardProps) {
  return (
    <motion.div className={className} variants={cardMotionVariants}>
      <Card className="bg-card-bg dark:bg-secondary h-full shadow-none">
        <CardHeader className="justify-end">
          {/* Decorative background corner */}
          <div
            aria-hidden="true"
            className="bg-card-accent-dark absolute z-0 flex h-12 w-12 flex-col items-end justify-end overflow-hidden rounded-lg align-bottom dark:bg-white"
          >
            <div className="bg-card-accent-light h-8 w-2 rounded-ss-md" />
          </div>

          {/* Card number badge */}
          <div
            aria-label={`Feature ${number}`}
            className="dark:text-primary z-50 flex h-12 w-12 flex-col items-center justify-center overflow-hidden rounded-lg font-bold text-white"
            role="img"
          >
            {number}
          </div>
        </CardHeader>

        <CardContent className="mb-7 flex-col items-start text-start">
          <Title className="text-sm">{title}</Title>
          <Description className="pt-3">{description}</Description>
        </CardContent>
      </Card>
    </motion.div>
  );
}
